import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import handleDropdownKeyPress from '../../common/handleDropdownKeyPress';
import ColorPicker from '../ColorPicker/ColorPicker';

export default class BlockColorPicker extends PureComponent {
    onCloseClick = (event) => {
        const { onClose } = this.props;
        event.stopPropagation();
        onClose();
    };

    render() {
        const {
            type,
            color,
            shouldDisplayColorPicker,
            onClick,
            onChangeComplete,
            presetColors,
            hasFullStylingAccess,
            hasCustomizationFeature,
            hasCustomizationAccess,
        } = this.props;
        return (
            <Styled.BlockColorPickerDiv>
                <Styled.Div
                    onClick={onClick}
                    onKeyDown={(e) =>
                        handleDropdownKeyPress(
                            e,
                            () => onClick(e),
                            () => this.onCloseClick(e)
                        )
                    }
                    tabIndex={0}
                    data-test-id="block-color-picker"
                >
                    {type === 'outer' ? (
                        <Styled.OuterBackgroundComponent
                            className="outer"
                            fillColor={color}
                            style={{ position: 'absolute', width: 24, height: 24, left: 2, top: 'calc(50% - 12px)' }}
                        />
                    ) : (
                        <Styled.InnerBackgroundComponent className="inner" fillColor={color} />
                    )}

                    <Styled.ColorSpan>{color}</Styled.ColorSpan>
                    <Styled.IconSpan>
                        <Styled.Icon className="material-icons">arrow_drop_down</Styled.Icon>
                    </Styled.IconSpan>
                </Styled.Div>
                {shouldDisplayColorPicker ? (
                    <Styled.ColorPickerDiv>
                        <Styled.ColorPicker
                            data-test-id="block-color-picker-close"
                            onClick={(e) => this.onCloseClick(e)}
                            tabIndex={0}
                        />

                        {hasFullStylingAccess ? (
                            <ColorPicker
                                hasFullStylingAccess
                                hasCustomizationFeature={hasCustomizationFeature}
                                hasCustomizationAccess={hasCustomizationAccess}
                                disableAlpha
                                color={color}
                                presetColors={presetColors}
                                onChangeComplete={onChangeComplete}
                                width={160}
                            />
                        ) : (
                            <>
                                <div style={{ marginTop: 6 }}>
                                    <ColorPicker
                                        color={color}
                                        presetColors={presetColors}
                                        onChangeComplete={onChangeComplete}
                                    />
                                </div>
                            </>
                        )}
                    </Styled.ColorPickerDiv>
                ) : null}
            </Styled.BlockColorPickerDiv>
        );
    }
}

BlockColorPicker.propTypes = {
    type: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    shouldDisplayColorPicker: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onChangeComplete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    presetColors: PropTypes.array.isRequired,
    hasFullStylingAccess: PropTypes.bool,
    hasCustomizationFeature: PropTypes.bool,
    hasCustomizationAccess: PropTypes.bool,
};

BlockColorPicker.defaultProps = {
    hasFullStylingAccess: true,
    hasCustomizationFeature: false,
    hasCustomizationAccess: false,
};
